import { CounsellingIntakeAssessmentResponse } from './cia.model';

// What a saved assessment puts into the plain fields of each group of the form; the rows are built by cia-fixed-rows.

export function presentingValue(item: CounsellingIntakeAssessmentResponse) {
  return {
    intakeDate: item.intakeDate ?? '',
    intakeTime: item.intakeTime ? item.intakeTime.slice(0, 5) : '',
    presentingProblemDescription: item.presentingProblemDescription ?? '',
    presentingProblemDurationId: item.presentingProblemDurationId ?? '',
    presentingProblemSeverityId: item.presentingProblemSeverityId ?? '',
    previousEpisodes: item.previousEpisodes ?? '',
    previousInterventions: item.previousInterventions ?? '',
  };
}

export function functionalRiskValue(item: CounsellingIntakeAssessmentResponse) {
  return {
    underlyingProblemIds: (item.underlyingProblems ?? []).filter((row) => row.isActive).map((row) => row.problemId),
    functionalImpactSeverityId: item.functionalImpactSeverityId ?? '',
    riskRatingId: item.riskRatingId ?? '',
  };
}

export function treatmentValue(item: CounsellingIntakeAssessmentResponse) {
  return {
    clinicalImpressions: item.clinicalImpressions ?? '',
    treatmentPlanSummary: item.treatmentPlanSummary ?? '',
  };
}
